var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBathsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "baths-icon_svg__a",
    d: "M0 .876h44.734v4.476H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "baths-icon_svg__c",
    d: "M.503.82h3.131V4H.504z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "baths-icon_svg__e",
    d: "M.808 0h9.697v18.713H.808z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "baths-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#baths-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.104 2.54a.442.442 0 00-.441.44v.267c0 .243.199.441.44.441H42.63a.442.442 0 00.442-.44V2.98a.442.442 0 00-.442-.44H2.104zm40.525 2.812H2.104A2.107 2.107 0 010 3.247V2.98C0 1.82.944.876 2.104.876h40.525c1.162 0 2.105.944 2.105 2.104v.267a2.106 2.106 0 01-2.105 2.105z",
    fill: "currentColor",
    mask: "url(#baths-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "baths-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#baths-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.397.82H1.766a.24.24 0 00-.222.153L.519 3.677A.238.238 0 00.74 4h1.63a.24.24 0 00.222-.154l1.026-2.704A.238.238 0 003.397.82",
    fill: "currentColor",
    mask: "url(#baths-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.267 36.678l-1.026-2.704a.237.237 0 00-.222-.153h-1.63a.24.24 0 00-.196.102.242.242 0 00-.026.22l1.027 2.704a.236.236 0 00.221.153h1.63a.24.24 0 00.197-.103.24.24 0 00.025-.22",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09 22.352l.715 3.339c.737 5.18 3.98 8.363 8.472 8.363h16.18c4.492 0 7.736-3.182 8.462-8.306l.726-3.396H5.09zm25.366 13.365H14.277c-5.3 0-9.269-3.821-10.108-9.735l-.922-4.287a.833.833 0 01.813-1.006h36.613c.252 0 .49.113.646.309.16.195.22.452.167.697l-.93 4.345c-.83 5.856-4.799 9.677-10.1 9.677zM35.689 11.073c-.307.374-.538.745-.54.888a.54.54 0 001.08 0c-.002-.141-.235-.516-.54-.888m0 2.378c-.822 0-1.49-.67-1.49-1.49 0-.7.88-1.656 1.149-1.933l.34-.35.342.35c.268.277 1.149 1.234 1.149 1.933 0 .82-.668 1.49-1.49 1.49M29.156 11.073c-.307.374-.538.745-.54.888a.54.54 0 001.08 0c-.002-.141-.235-.516-.54-.888m0 2.378c-.822 0-1.49-.67-1.49-1.49 0-.7.88-1.656 1.149-1.933l.34-.35.342.35c.268.277 1.149 1.234 1.149 1.933 0 .82-.668 1.49-1.49 1.49M32.907 13.232c-.232.29-.406.569-.414.686a.413.413 0 00.826-.003c-.008-.113-.183-.393-.412-.683m0 2.046a1.364 1.364 0 01-1.364-1.364c0-.617.716-1.418 1.024-1.733l.34-.348.34.348c.307.316 1.022 1.116 1.022 1.734 0 .752-.611 1.363-1.362 1.363",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.319 8.461h8.64c-.347-2.407-2.341-3.492-4.32-3.492-1.98 0-3.974 1.087-4.32 3.492m9.522 1.663H27.436a.83.83 0 01-.831-.831c-.002-3.555 2.48-5.987 6.034-5.987s6.036 2.432 6.036 5.913c0 .46-.374.905-.834.905",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "baths-icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#baths-icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.505 18.713H8.842V4.462a2.803 2.803 0 00-2.8-2.8H4.606A2.138 2.138 0 002.47 3.799v.832l-1.662.05v-.882A3.802 3.802 0 014.606 0h1.436a4.468 4.468 0 014.463 4.462v14.25z",
    fill: "currentColor",
    mask: "url(#baths-icon_svg__f)"
  })))));
}
export default SvgBathsIcon;